// extracted by mini-css-extract-plugin
export var button = "_79-7";
export var buttonRow = "_79-6";
export var fadeIn = "_79-1";
export var gradient = "_79-0";
export var panel = "_79-2";
export var panelIn = "_79-3";
export var subtitle = "_79-5";
export var title = "_79-4";